import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

import { cn } from "@/utils/misc";

const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useState<"light" | "dark">(
    localStorage.theme === "dark" ? "dark" : "light",
  );
  const [initialized, setInitialized] = useState(false);

  // A similar script is inlined in the <head> of index.html.
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      return;
    }
    localStorage.theme = currentTheme;
    if (currentTheme === "dark") {
      document.documentElement.classList.add("dark");
      document.documentElement.style.colorScheme = "dark";
    } else {
      document.documentElement.classList.remove("dark");
      document.documentElement.style.colorScheme = "light";
    }
  }, [currentTheme, initialized]);

  const toggleTheme = () => {
    setCurrentTheme(currentTheme === "light" ? "dark" : "light");
  };

  return [currentTheme, toggleTheme] as const;
};

export function ThemeSwitcher({ triggerClass }: { triggerClass?: string }) {
  const [currentTheme, toggleTheme] = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={cn(
        "flex h-6 items-center justify-center rounded border border-primary/20 bg-secondary px-2 hover:border-primary/40 transition-colors",
        triggerClass,
      )}
    >
      {currentTheme === "light" ? (
        <Moon className="h-[14px] w-[14px]" />
      ) : (
        <Sun className="h-[14px] w-[14px]" />
      )}
    </button>
  );
}

export function ThemeSwitcherHome() {
  const [currentTheme, toggleTheme] = useTheme();
  return (
    <button onClick={toggleTheme} name="theme">
      {currentTheme === "light" ? (
        <Moon className="h-4 w-4 text-primary/80 hover:text-primary" />
      ) : (
        <Sun className="h-4 w-4 text-primary/80 hover:text-primary" />
      )}
    </button>
  );
}
